<app-admin-page-section titleT="admin.reports.terms-updates-report">
  <div class="admin-action-item-list">

    <!-- Edit terms update page -->
    <app-admin-action-item titleT="admin.batch-creation.terms-updates-edit-title">
      <div class="buttons-container">
        <app-link-button icon="edit_icon" text="English" (clicked)="openEditTerms('English')" />
        <app-link-button icon="edit_icon" text="German" (clicked)="openEditTerms('German')" />
      </div>
    </app-admin-action-item>

    <!-- Terms updates report -->
    <app-admin-action-item titleT="admin.reports.terms-updates-report">
      <app-button-indicator-download [isPending]="termsUpdatesReportPending.isPending()"
        (clicked)="downloadTermsUpdatesReport()" />
    </app-admin-action-item>

    <!-- Upload XSLX file -->
    <app-admin-action-item titleT="admin.batch-creation.upload-file">
      <app-button-indicator-upload toolTipT="admin.batch-creation.upload-file-customer-spaces-terms-update-tooltip"
        [isPending]="false" (clicked)="openXlsxCustomerSpaceIdsTermsFileUploadDialog()" />
    </app-admin-action-item>

  </div>
</app-admin-page-section>